'use strict';

var App = require('app');
var Consts = require('consts');
var Misc = require('utils/misc');

var ChartData = Marionette.Object.extend({
    state: {},
    urlBase: '/api/v1/devices/{id}/chart',
    deviceId: undefined,
    basisData: undefined,
    basisDataInterpolated: undefined,
    rawData: undefined,
    rawDataInterpolated: undefined,
    dataFrom: undefined,
    dataTill: undefined,
    Data: undefined,
    maxPointCount: 2000,
    minPointDifferenceSecs: 10,
    includeDefaultMinMax: true,
    initialize: function (options) {
        this.deviceId = options.deviceId;
    },

    selectedSeries: [],

    isEmpty: function () {
        return !this.rawData || this.rawData.length == 0;
    },

    // returns first datetime in the current data set
    getFirstTime: function () {
        var min = undefined;
        for (var i = 0; i < this.rawData.length; i++) {
            var isEmpty = true;
            for (var j = 1; j < this.rawData[i].length; j++) {
                if (this.rawData[i][j] !== null && this.rawData[i] !== undefined) {
                    isEmpty = false;
                    break;
                }
            }
            if (!isEmpty) {
                min = this.rawData[i][0];
                break;
            }
        }

        if (min === undefined) return min;
        return new Date(min * 1000).getTime();
    },

    // returns data which are relevant for given chart strip
    compose: function (isBinary, index, from, till) {
        var self = this;
        var bIdx = 0;
        var result = [];
        var interpolated = [];
        var labels = [];
        var colors = [];
        var series = [];
        var units = [];
        var min = undefined;
        var max = undefined;
        var indexList = [];

        // choose which series are going to be displayed in the current chart
        for (var i = 0; i < this.selectedSeries.length; i++) {
            var bShow = false;
            if (this.selectedSeries[i].isBinary) bShow = bIdx == index && isBinary;
            else bShow = !isBinary;

            if (bShow) {
                indexList.push(i);
            }

            if (this.selectedSeries[i].isBinary) bIdx++;
        }

        if (!this.rawData) {
            this.rawData = [];
        }

        for (var i = 0; i < this.rawData.length; i++) {
            var row = [new Date(this.rawData[i][0] * 1000)];
            interpolated[i] = 0;

            for (var j = 0; j < indexList.length; j++) {
                var sourceBit = 1 << indexList[j];
                var destBit = 1 << j;

                if (i == 0) {
                    var serie = this.selectedSeries[indexList[j]];
                    labels[j + 1] = serie.label;
                    colors[j] = serie.color;
                    series[j] = serie;
                    units[j] = serie.unit;
                }

                var currentUnit = units[j];

                if (this.rawDataInterpolated && (this.rawDataInterpolated[i] & sourceBit) > 0) {
                    interpolated[i] = interpolated[i] | destBit;
                }

                var v = this.rawData[i][1 + indexList[j]];
                if (isBinary) {
                    v = v !== null ? Math.max(Math.min(Math.round(v), 1), 0) : v;
                }

                // correct time values
                if (currentUnit == 'Uhr' && v !== null) {
                    v = Math.floor(v);
                    if (v % 100 >= 60) {
                        v = v - (v % 100) + 59;
                    }
                }

                if (min > v || min === undefined) min = v;
                if (max < v || max === undefined) max = v;

                row.push(v);
            }

            result.push(row);
        }

        if (isBinary && max < 1) max = 2;

        if (!result || result.length == 0) {
            result = [];
            result.push([new Date(from), 0]);
            result.push([new Date(till), 0]);

            interpolated = [1, 1];
            colors = ['black', 'black'];
            labels = ['', 'Data'];
            min = [0];
            max = [100];
        }

        var usedLabels = {};
        _.each(labels, function (l, i) {
            if (usedLabels[l]) {
                usedLabels[l]++;
                labels[i] = l + ' ' + usedLabels[l];
                series[i - 1].label = labels[i];
            } else {
                usedLabels[l] = 1;
            }
        });

        return {
            data: result,
            series: series,
            interpolated: interpolated,
            labels: labels,
            colors: colors,
            min: isBinary ? 0 : min,
            max: isBinary ? 1 : max,
        };
    },

    getRequestData: function (from, from0, till, resolution, fields) {
        var req = {
            from0: from0,
            from: from,
            till: till,
            resolution: resolution,
            fields: fields,
            timezone: new Date().getTimezoneOffset() * 60,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        // if there are differences requested, shift from
        var isDiff = Misc.selectWhereFirst(fields, function (a) {
            return a.difference > 0;
        });

        if (isDiff) {
            var ranges = Misc.selectWhere(
                fields,
                function (a) {
                    return a.difference > 0;
                },
                function (a) {
                    switch (a.actual_time_window) {
                        case 'year':
                            return 366 * 24 * 60;
                        case 'month':
                            return 32 * 24 * 60;
                    }
                    return a.timewindow;
                }
            );

            var maxRange = Math.max(_.max(ranges) * 60, resolution);
            req.origFrom = from;
            req.from = req.from - maxRange;
        }

        return req;
    },

    getURL: function () {
        return this.urlBase.replace('{id}', this.deviceId);
    },

    requestData: function (request) {
        App.ajax({
            url: this.getURL(),
            data: request.data,
            method: 'POST',

            success: function (data) {
                // invalid: everything null in the row and both neighbor rows
                var isValid = function (i) {
                    var a = data.values[i];
                    if (a === undefined) {
                        return false;
                    }

                    for (var j = 1; j < a.length; j++) {
                        if (a[j] !== undefined && a[j] !== null) {
                            return true;
                        }
                    }
                    return false;
                };

                var newValues = [];
                var newInterpolated = [];

                var begin = 0;
                var fromTime = new Date(request.origFrom || request.from);
                fromTime = fromTime.getTime() / 1000;

                while (begin < data.values.length && (!isValid(begin) || data.values[begin][0] < fromTime)) {
                    begin++;
                }

                if (begin < data.values.length) {
                    newValues.push(data.values[begin]);
                    newInterpolated.push(data.interpolated[begin]);
                    begin++;
                }

                for (var i = begin + 1; i < data.values.length; i++) {
                    if (isValid(i) || isValid(i - 1) || isValid(i - 2)) {
                        newValues.push(data.values[i - 1]);
                        newInterpolated.push(data.interpolated[i - 1]);
                    }
                }

                newValues.push(data.values[data.values.length - 1]);
                newInterpolated.push(data.interpolated[data.interpolated.length - 1]);

                var lastItem = data.values.length - 1;
                while (!isValid(lastItem) && lastItem > 0) {
                    lastItem--;
                }

                newValues = newValues.slice(0, lastItem + 1);
                newInterpolated = newInterpolated.slice(0, lastItem + 1);

                request.success({
                    interpolated: newInterpolated,
                    values: newValues,
                    meterChange: data.meter_change,
                    eventlog: data.event_log,
                    timeshift: data.timeshift,
                });
            },

            error: function () {
                if (request.error) {
                    request.error();
                }
            },
        });
    },

    normalize: function (data, initialSettings) {
        var getMinMax = function (line) {
            var r = { min: undefined, max: undefined };
            _.each(data.data, function (row) {
                var v = row[line];
                if (v !== null) {
                    if (r.min === undefined || r.min > v) r.min = v;
                    if (r.max === undefined || r.max < v) r.max = v;
                }
            });

            return r;
        };

        var calcAllMinMax = function () {
            _.each(data.series, function (s, i) {
                var m = getMinMax(i + 1);

                s.actualMin = m.min === null || isNaN(m.min) ? (s.min != s.max ? s.min : m.min) : m.min;
                s.actualMax = m.max === null || isNaN(m.max) ? (s.min != s.max ? s.max : m.max) : m.max;

                var n = Misc.normalizeRange(
                    {
                        min: s.actualMin,
                        max: s.actualMax,
                    },
                    { limits: { min: s.min, max: s.max } }
                );
                s.actualMin = n.min;
                s.actualMax = n.max;

                s.valueMin = m.min;
                s.valueMax = m.max;
                s.actualCenter = (s.actualMin + s.actualMax) / 2;
                s.actualRange = s.actualMax - s.actualMin;
                s.actualIsConstant = m.min == m.max;
            });
        };

        var isCompatibleTemp = function (sourceUnit, s) {
            if (sourceUnit != '°C') return false;
            if (s.min == -400 && s.max == 1600) return true;
            if (s.min == 0 && s.max == 200) return true;
            if (s.field && s.field.startsWith('WD_')) return true;
            return false;
        };

        var assignSeriesToAxes = function () {
            var axisToSeries = {};
            var axisCounter = 0;

            var getSource = function (series) {
                var src =
                    '' +
                    series.field +
                    (series.op && series.secondDeviceID && !isNaN(series.secondDeviceID) ? series.secondField : '');
                return src;
            };

            var canAssign = function (sourceSerie, targetSerie) {
                var sourceUnit = sourceSerie.display_unit || sourceSerie.unit;
                var targetUnit = targetSerie.display_unit || targetSerie.unit;

                // same source? assign to the same axis
                if (getSource(sourceSerie) == getSource(targetSerie)) {
                    return true;
                }

                if (sourceUnit != targetUnit) return false;
                if (sourceUnit == '') return false;

                if (sourceSerie.actualMin === null || isNaN(sourceSerie.actualMin)) return false;

                // both constant? -> always accept
                if (sourceSerie.actualRange == 0 && targetSerie.actualRange == 0) return true;

                // standard temperatures? -> assign to same axis
                if (isCompatibleTemp(sourceUnit, sourceSerie) && isCompatibleTemp(targetUnit, targetSerie)) return true;

                // standard percentage? -> assign to same axis
                if (sourceUnit == '%' && sourceSerie.min == 0 && sourceSerie.max == 100) return true;

                // standard pressure? -> assign to same axis
                if (sourceUnit == 'bar' && sourceSerie.min == 0 && sourceSerie.max == 1000) return true;

                // decide based on value range and center
                var r1 = Math.min(sourceSerie.actualRange, targetSerie.actualRange);
                var r2 = Math.max(sourceSerie.actualRange, targetSerie.actualRange);

                var ratio = r2 / r1;
                if (ratio > 50 && !sourceSerie.actualIsConstant && !targetSerie.actualIsConstant) return false;

                ratio =
                    Math.abs(sourceSerie.actualCenter - targetSerie.actualCenter) /
                    Math.max(targetSerie.actualRange, sourceSerie.actualRange);

                return ratio <= 20;
            };

            // clear all series assignments
            _.each(data.series, function (s) {
                s.actualAxis = undefined;
            });

            _.each(data.series, function (s, i) {
                // try to assign existing
                _.each(axisToSeries, function (serie, axis) {
                    if (canAssign(s, data.series[serie])) {
                        s.actualAxis = parseInt(axis);
                    }
                });

                if (s.actualAxis !== undefined) return;

                axisToSeries[axisCounter] = i;
                s.actualAxis = axisCounter;
                axisCounter++;
            });

            data.axes = {};
            _.each(data.series, function (s, i) {
                if (data.axes[s.actualAxis] === undefined) data.axes[s.actualAxis] = [i];
                else data.axes[s.actualAxis].push(i);
            });
        };

        var normalizeAxes = function () {
            var axisRanges = {};
            // get min and max
            _.each(data.series, function (s, i) {
                if (axisRanges[s.actualAxis]) {
                    axisRanges[s.actualAxis].min = Math.min(axisRanges[s.actualAxis].min, s.actualMin);
                    axisRanges[s.actualAxis].max = Math.max(axisRanges[s.actualAxis].max, s.actualMax);
                } else {
                    axisRanges[s.actualAxis] = { min: s.actualMin, max: s.actualMax };
                }
            });

            _.each(axisRanges, function (r) {
                var n = Misc.normalizeRange(r, { addPadding: true });
                r.max = n.max;
                r.min = n.min;
            });

            // write back
            _.each(data.series, function (s, i) {
                s.actualMin = axisRanges[s.actualAxis].min;
                s.actualMax = axisRanges[s.actualAxis].max;
            });
        };

        var normalizeSeries = function () {
            data.normalized = [];
            _.each(data.series, function (serie, serieIdx) {
                // calculate k and q
                var sideSerie = data.series[0];
                var k = (sideSerie.actualMax - sideSerie.actualMin) / (serie.actualMax - serie.actualMin);
                var q = sideSerie.actualMax - k * serie.actualMax;

                serie.axisCalc = {
                    k: k,
                    q: q,
                };

                _.each(data.data, function (row, i) {
                    if (data.normalized[i] === undefined) data.normalized[i] = [row[0]];
                    data.normalized[i][serieIdx + 1] =
                        data.data[i][serieIdx + 1] !== null ? k * data.data[i][serieIdx + 1] + q : null;
                });
            });
        };

        if (initialSettings) {
            _.each(initialSettings, function (s, i) {
                if (!data.series[i]) return;
                data.series[i].actualMin = s.min;
                data.series[i].actualMax = s.max;
                data.series[i].actualAxis = s.axis;
            });
        } else {
            calcAllMinMax();
            assignSeriesToAxes();
            normalizeAxes();
        }
        normalizeSeries();

        // return data that are relevant for keeping the axis same: assignment of series to axes, axes min max
        var axisSettings = _.map(data.series, function (a) {
            return {
                min: a.actualMin,
                max: a.actualMax,
                axis: a.actualAxis,
            };
        });
        return axisSettings;
    },

    getSelectedSeriesFields: function () {
        var result = [];
        for (var i = 0; i < this.selectedSeries.length; i++) {
            result.push(this.selectedSeries[i].field);
        }
        return result;
    },

    getResolution: function (from, till) {
        var self = this;

        var diff = till - from;
        var pixelCounts = _.map(Consts.ChartTimeWindows(), function (w) {
            return { mins: w.mins, cnt: diff / (60 * w.mins) };
        });

        // find the best greater point count than width
        pixelCounts = _.filter(pixelCounts, function (a) {
            return a.cnt > self.maxPointCount;
        });
        var diffMin = (pixelCounts.length > 0 ? pixelCounts[pixelCounts.length - 1].mins : 1) || 1;

        // 10000 seems to be internal limit of influx
        var dm = diff / 60;
        while (dm / diffMin > 10000) {
            diffMin = diffMin * 2;
        }

        return diffMin * 60;
    },

    updateTimeWindow: function (from, till) {
        var tv = (till - from) / 20;
        tv = Math.floor(tv / 60);

        // more than 1 hr? fix it to hours
        if (tv > 60) tv = tv - (tv % 60);

        // more than 1 day? fix it to days
        if (tv > 1440) tv = tv - (tv % 1440);

        // is it 0? fix it to 1
        if (tv < 1) {
            tv = 1;
        }

        this.autoTimeWindow = tv;
    },

    getSelectedFields: function () {
        var self = this;
        return _.map(this.selectedSeries, function (a, index) {
            var f = {
                device: parseInt(a.deviceID),
                index: index,
                lat: a.lat,
                lon: a.lon,
                field: a.field,
                op: a.op,
                device2: parseInt(a.secondDeviceID),
                lat2: a.lat2,
                lon2: a.lon2,
                field2: a.secondField,
                aggregation: (a.displaySettings && a.displaySettings.aggregationFunc) || 'MEAN',
                difference:
                    (a.displaySettings && a.displaySettings.aggregationFunc && a.displaySettings.difference) || 0,
                type: (a.displaySettings && a.displaySettings.aggregationFunc && a.displaySettings.chartType) || 0,
                timeshift: a.displaySettings && a.displaySettings.timeshift,
                timewindow:
                    (a.displaySettings &&
                        a.displaySettings.aggregationFunc &&
                        a.displaySettings.timeWindow &&
                        Misc.selectWhereFirst(
                            Consts.ChartTimeWindows(),
                            function (cw) {
                                return cw.id == a.displaySettings.timeWindow;
                            },
                            'mins'
                        )) ||
                    0,
                actual_time_window:
                    (a.displaySettings &&
                        a.displaySettings.aggregationFunc &&
                        a.displaySettings.timeWindow &&
                        Misc.selectWhereFirst(
                            Consts.ChartTimeWindows(),
                            function (cw) {
                                return cw.id == a.displaySettings.timeWindow;
                            },
                            'actual'
                        )) ||
                    '',
            };
            if (f.timewindow <= 0 && f.type == 1) {
                // the time window will calculated automatically
                f.timewindow = self.autoTimeWindow;
            }
            return f;
        });
    },

    loadData: function (from, till, onDataLoaded, onError, enhanceResReload) {
        var self = this;

        var fromSecs = from.getTime() / 1000;
        var tillSecs = till.getTime() / 1000;
        var resolution = this.getResolution(fromSecs, tillSecs);

        this.updateTimeWindow(fromSecs, tillSecs);

        var fields = this.getSelectedFields();
        var data = this.getRequestData(fromSecs, fromSecs, tillSecs, resolution, fields);

        this.requestData({
            from: from,
            fromLoadData: true,
            data: JSON.stringify(data),
            fields: fields,

            error: function (err) {
                if (onError) {
                    onError(err);
                }
            },
            success: function (values) {
                self.rawData = values.values;
                self.rawDataInterpolated = values.interpolated;
                self.meterChange = values.meterChange;
                self.eventlog = values.eventlog;
                self.timeshift = values.timeshift;
                self.request = data;

                if (self.rawData === undefined) {
                    self.rawData = [
                        [0, 0],
                        [1, 0],
                    ];
                }

                if (enhanceResReload && self.rawData.length > 0) {
                    var dataRange = {
                        from: self.rawData[0][0],
                        till: self.rawData[self.rawData.length - 1][0],
                    };

                    var newResolution = self.getResolution(dataRange.from, dataRange.till);
                    if (newResolution != resolution) {
                        self.loadData(
                            new Date(dataRange.from * 1000),
                            new Date(dataRange.till * 1000),
                            onDataLoaded,
                            onError,
                            false
                        );
                        return;
                    }
                }

                self.basisData = $.extend([], true, self.rawData);
                self.basisDataInterpolated = $.extend([], true, self.rawDataInterpolated);

                self.dataFrom = from;
                self.dataTill = till;

                if (onDataLoaded) {
                    onDataLoaded(values);
                }
            },
        });
    },
});

var API = {
    getMeterData: function (deviceId, from, till, resolution, field, actualTimeWindow, chartId) {
        var defer = $.Deferred();

        var chartData = new ChartData({ deviceId: deviceId });
        chartData.requestData({
            data: JSON.stringify({
                from: from,
                till: till,
                resolution: resolution * 60,
                fields: [
                    {
                        device: deviceId,
                        field: field,
                        aggregation: 'MAX',
                        difference: 1,
                        type: 1,
                        timewindow: resolution,
                        actual_time_window: actualTimeWindow,
                    },
                ],
                timezone: new Date().getTimezoneOffset() * 60,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }),

            success: function (rawData) {
                var result = {
                    failed: false,
                    fields: field,
                    chartId: chartId,
                };

                // remove null and convert values
                result.values = Misc.selectWhere(
                    rawData.values,
                    function (a) {
                        return a.length == 2 && a[0] > 0 && a[1] !== null && a[1] !== undefined;
                    },
                    function (a) {
                        var row = a.slice();
                        row[0] = new Date(a[0] * 1000);
                        return row;
                    }
                );

                // filter events -> store meter replacement timestamps
                result.replaced = Misc.selectWhere(
                    rawData.eventlog,
                    function (a) {
                        return a.item_type == 'device_replacement';
                    },
                    function (a) {
                        return Date.parse(a.event_time);
                    }
                );

                result.values.shift();
                defer.resolve(result);
            },
        });

        return defer.promise();
    },

    getMeterDataRaw: function (deviceId, from, till, resolution, field, options) {
        var defer = $.Deferred();

        options = options || {};
        var requestFields = {
            device: deviceId,
            field: field,
            aggregation: options.aggregation || 'MAX',
            difference: options.difference || 0,
            type: options.type || 1,
            timewindow: resolution,
            actual_time_window: options.actualTimeWindow || 'month',
        };

        var chartData = new ChartData({ deviceId: deviceId });
        chartData.requestData({
            data: JSON.stringify({
                from: from,
                till: till,
                resolution: resolution * 60,
                fields: [requestFields],
                timezone: new Date().getTimezoneOffset() * 60,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }),

            success: function (rawData) {
                defer.resolve(rawData);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler(
    'charts:meter:data',
    function (deviceId, from, till, resolution, field, actualTimeWindow, chartId) {
        return API.getMeterData(deviceId, from, till, resolution, field, actualTimeWindow, chartId);
    }
);

App.reqres.setHandler('charts:meter:data:raw', function (deviceId, from, till, resolution, field, options) {
    return API.getMeterDataRaw(deviceId, from, till, resolution, field, options);
});

module.exports = ChartData;
